export default function translate(message, replacements = {}) {
	let line = message;
	
	if (
		"undefined" !== typeof InterNACHI
		&& "undefined" !== typeof InterNACHI.shared
		&& "undefined" !== typeof InterNACHI.shared.i18n_translations
		&& "undefined" !== typeof InterNACHI.shared.i18n_translations[message]
		&& "" !== InterNACHI.shared.i18n_translations[message]
	) {
		line = InterNACHI.shared.i18n_translations[message];
	}
	
	return replace(line, replacements);
}

export function trans_choice(message, count, replacements = {}) {
	const line = translate(message, replacements);
	const segments = line.split('|');
	const segment = 1 === count
		? segments[0]
		: segments[1];
	
	return replace(segment, { count });
}

function replace(message, replacements) {
	const finder = text => new RegExp(`:${ text }`, 'g');
	const ucfirst = text => text.charAt(0).toUpperCase() + text.slice(1);
	
	Object.keys(replacements)
		.sort((a, b) => b.length - a.length)
		.forEach(key => {
			let replacement = `${ replacements[key] }`;
			message = message.replace(finder(key), replacement);
			message = message.replace(finder(key.toUpperCase()), replacement.toUpperCase());
			message = message.replace(finder(ucfirst(key)), ucfirst(replacement));
		});
	
	return message;
}
